var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEtf = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#1072BA",
  fillOpacity: 0.85
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.89176 10.15V11.9H9.24176V13.01H6.89176V14.86H9.54176V16H5.49176V9.01H9.54176V10.15H6.89176ZM15.564 9.02V10.15H13.704V16H12.304V10.15H10.444V9.02H15.564ZM20.8955 9.02V10.15H17.9855V11.94H20.2155V13.05H17.9855V16H16.5855V9.02H20.8955Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEtf);
export { ForwardRef as ReactComponent };